<ion-header>
  <ion-toolbar mode="md" class="ion-no-padding">
    <div class="headerBg esignPadding">
      <div class="headerRow">
        <ion-title class="ion-no-padding esignTitle">
          Submit E-sign
        </ion-title>
        <ion-button (click)="close()" fill="clear" class="ion-no-padding close-button">
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      </div>
      <p class="subtitle">
        Please confirm below that all your information was entered correctly, and then complete the eSign at the
        bottom of
        the page in order to proceed.
      </p>
    </div>

  </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding offer-modal-content">
  <!-- <div class="bgHighlight esignPadding">
    <div class="custom-header" *ngIf="isWebView">
      <ion-button fill="clear" class="close-button" (click)="close()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </div>
    <h2 class="esignTitle">Submit E-sign</h2>
    <p class="subtitle">
      Please confirm below that all your information was entered correctly, and then complete the eSign at the bottom of
      the page in order to proceed.
    </p>
  </div> -->
  <div class="contentAreaWrapper esignPadding">
    <div class="infoItem">
      <div class="itemHeader">
        <h3 class="item-title esignTitle">Business Information</h3>
        <ion-button fill="clear" class="m-0 esignCTABtn"
          (click)="isBusinessInfoEditMode? updateBusinessInfo() : toggleBusinessInfoEdit() ">
          @if(!isBusinessInfoEditMode) {
          Edit Info <ion-icon name="create-outline"></ion-icon>
          }
          @else {
          Save Info <ion-img src="assets/images/icons/save_icon.svg"></ion-img>
          }
        </ion-button>
      </div>
      <div class="itemContent">
        <div class="info-grid">
          <!-- Row 1 -->
          <div class="info-row">
            <div class="info-field">
              <p class="field-label">Business Name</p>
              <p *ngIf="!isBusinessInfoEditMode" class="field-value">{{ businessInfo.businessName }}</p>
              <ion-item *ngIf="isBusinessInfoEditMode" lines="none">
                <ion-input [(ngModel)]="businessInfo.businessName" class="general-input-custom"
                  fill="outline"></ion-input>
              </ion-item>
            </div>

            <div class="info-field">
              <p class="field-label">Business Type/Industry Type</p>
              <p *ngIf="!isBusinessInfoEditMode" class="field-value">{{ businessInfo.businessType }}</p>
              <ion-item *ngIf="isBusinessInfoEditMode" lines="none">
                <ion-input [(ngModel)]="businessInfo.businessType" class="general-input-custom"
                  fill="outline"></ion-input>
              </ion-item>
            </div>
          </div>

          <!-- Row 2 -->
          <div class="info-row">
            <div class="info-field">
              <p class="field-label">Business Address</p>
              <p *ngIf="!isBusinessInfoEditMode" class="field-value">{{ businessInfo.businessAddress }}</p>
              <ion-item *ngIf="isBusinessInfoEditMode" lines="none">
                <ion-input [(ngModel)]="businessInfo.businessAddress" class="general-input-custom"
                  fill="outline"></ion-input>
              </ion-item>
            </div>

            <div class="info-field">
              <p class="field-label">Average Monthly Revenue/Deposits</p>
              <p *ngIf="!isBusinessInfoEditMode" class="field-value">{{ businessInfo.avgMonthlyRevenue }}</p>
              <ion-item *ngIf="isBusinessInfoEditMode" lines="none">
                <ion-input [(ngModel)]="businessInfo.avgMonthlyRevenue" class="general-input-custom"
                  fill="outline"></ion-input>
              </ion-item>
            </div>
          </div>

          <!-- Row 3 -->
          <div class="info-row">
            <div class="info-field">
              <p class="field-label">Business Start Date</p>
              <p *ngIf="!isBusinessInfoEditMode" class="field-value">{{ businessInfo.businessStartDate }}</p>
              <ion-item *ngIf="isBusinessInfoEditMode" lines="none">
                <ion-input [(ngModel)]="businessInfo.businessStartDate" class="general-input-custom"
                  fill="outline"></ion-input>
              </ion-item>
            </div>

            <div class="info-field">
              <p class="field-label">Average Daily Bank Balances</p>
              <p *ngIf="!isBusinessInfoEditMode" class="field-value">{{ businessInfo.avgDailyBalance }}</p>
              <ion-item *ngIf="isBusinessInfoEditMode" lines="none">
                <ion-select [(ngModel)]="businessInfo.avgDailyBalance" class="general-input-custom" fill="outline"
                  interface="popover">
                  <ion-select-option value="0-5000">0-5000</ion-select-option>
                  <ion-select-option value="5000-10000">5000-10000</ion-select-option>
                  <ion-select-option value="10000-15000">10000-15000</ion-select-option>
                  <ion-select-option value="15000-20000">15000-20000</ion-select-option>
                  <ion-select-option value="20000+">20000+</ion-select-option>
                </ion-select>
              </ion-item>
            </div>
          </div>

          <!-- Row 4 -->
          <div class="info-row">
            <div class="info-field">
              <p class="field-label">Federal Tax ID</p>
              <p *ngIf="!isBusinessInfoEditMode" class="field-value">{{ businessInfo.federalTaxId }}</p>
              <ion-item *ngIf="isBusinessInfoEditMode" lines="none">
                <ion-input [(ngModel)]="businessInfo.federalTaxId" class="general-input-custom"
                  fill="outline"></ion-input>
              </ion-item>
            </div>

            <div class="info-field">
              <p class="field-label">Requested Funded Amount</p>
              <p *ngIf="!isBusinessInfoEditMode" class="field-value">{{ businessInfo.requestedAmount }}</p>
              <ion-item *ngIf="isBusinessInfoEditMode" lines="none">
                <ion-input [(ngModel)]="businessInfo.requestedAmount" class="general-input-custom"
                  fill="outline"></ion-input>
              </ion-item>
            </div>
          </div>

          <!-- Row 5 -->
          <div class="info-row">
            <div class="info-field">
              <p class="field-label">Legal Entity Type</p>
              <p *ngIf="!isBusinessInfoEditMode" class="field-value">{{ businessInfo.legalEntityType }}</p>
              <ion-item *ngIf="isBusinessInfoEditMode" lines="none">
                <ion-select [(ngModel)]="businessInfo.legalEntityType" class="general-input-custom" fill="outline"
                  interface="popover">
                  <ion-select-option value="LLC">LLC</ion-select-option>
                  <ion-select-option value="Corporation">Corporation</ion-select-option>
                  <ion-select-option value="Partnership">Partnership</ion-select-option>
                  <ion-select-option value="Sole Proprietorship">Sole Proprietorship</ion-select-option>
                </ion-select>
              </ion-item>
            </div>

            <div class="info-field">
              <p class="field-label">Do you have any current financing/loans?</p>
              <p *ngIf="!isBusinessInfoEditMode" class="field-value">{{ businessInfo.hasCurrentFinancing }}</p>
              <ion-item *ngIf="isBusinessInfoEditMode" lines="none">
                <ion-select [(ngModel)]="businessInfo.hasCurrentFinancing" class="general-input-custom" fill="outline"
                  interface="popover">
                  <ion-select-option value="Yes">Yes</ion-select-option>
                  <ion-select-option value="No">No</ion-select-option>
                </ion-select>
              </ion-item>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="infoItem">
      <div class="itemHeader">
        <h3 class="item-title esignTitle">Owner Information</h3>
        <ion-button fill="clear" class="m-0 esignCTABtn"
          (click)="isOwnerInfoEditMode? updateOwnerInfo() : toggleOwnerInfoEdit()">
          @if(!isOwnerInfoEditMode ) {
          Edit Info <ion-icon name="create-outline"></ion-icon>
          }
          @else {
          Save Info <ion-img src="assets/images/icons/save_icon.svg"></ion-img>
          }
        </ion-button>
      </div>
      <div class="itemContent">
        <div class="info-grid">
          <!-- Row 1 -->
          <div class="info-row">
            <div class="info-field">
              <p class="field-label">Owner Name</p>
              <p *ngIf="!isOwnerInfoEditMode " class="field-value">{{ ownerInfo.ownerName }}</p>
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-input [(ngModel)]="ownerInfo.ownerName" class="general-input-custom" fill="outline"></ion-input>
              </ion-item>
            </div>

            <div class="info-field">
              <p class="field-label">Phone</p>
              <p *ngIf="!isOwnerInfoEditMode " class="field-value">{{ ownerInfo.ownerPhone }}</p>
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-input [(ngModel)]="ownerInfo.ownerPhone" class="general-input-custom" fill="outline"></ion-input>
              </ion-item>
            </div>
          </div>

          <!-- Row 2 -->
          <div class="info-row">
            <div class="info-field">
              <p class="field-label">Address</p>
              <p *ngIf="!isOwnerInfoEditMode " class="field-value">{{ ownerInfo.ownerAddress }}</p>
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-input [(ngModel)]="ownerInfo.ownerAddress" class="general-input-custom" fill="outline"></ion-input>
              </ion-item>
            </div>

            <div class="info-field">
              <p class="field-label">Email</p>
              <p *ngIf="!isOwnerInfoEditMode " class="field-value">{{ ownerInfo.ownerEmail }}</p>
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-input [(ngModel)]="ownerInfo.ownerEmail" class="general-input-custom" fill="outline"></ion-input>
              </ion-item>
            </div>
          </div>

          <!-- Row 3 -->
          <div class="info-row">
            <div class="info-field">
              <p class="field-label">Business Start Date</p>
              <p *ngIf="!isOwnerInfoEditMode " class="field-value">{{ ownerInfo.ownerBusinessStartDate }}</p>
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-input [(ngModel)]="ownerInfo.ownerBusinessStartDate" class="general-input-custom"
                  fill="outline"></ion-input>
              </ion-item>
            </div>


            <div class="info-field">
              <p class="field-label">DOB</p>
              <p *ngIf="!isOwnerInfoEditMode " class="field-value">{{ ownerInfo.ownerDOB }}</p>
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-input [(ngModel)]="ownerInfo.ownerDOB" class="general-input-custom" fill="outline"></ion-input>
              </ion-item>
            </div>

            <!-- <div class="info-field">
              <p class="field-label">DOB</p>
              <p *ngIf="!isOwnerInfoEditMode " class="field-value">{{ businessInfo.avgDailyBalance }}</p>
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-select [(ngModel)]="businessInfo.avgDailyBalance" class="general-input-custom" fill="outline"
                  interface="popover">
                  <ion-select-option value="0-5000">0-5000</ion-select-option>
                  <ion-select-option value="5000-10000">5000-10000</ion-select-option>
                  <ion-select-option value="10000-15000">10000-15000</ion-select-option>
                  <ion-select-option value="15000-20000">15000-20000</ion-select-option>
                  <ion-select-option value="20000+">20000+</ion-select-option>
                </ion-select>
              </ion-item>
            </div>-->
          </div>

          <!-- Row 4 -->
          <div class="info-row">
            <div class="info-field">
              <p class="field-label">Owner Percentage:</p>
              <p *ngIf="!isOwnerInfoEditMode " class="field-value">{{ ownerInfo.ownerPercentOwnership }}</p>
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-input [(ngModel)]="ownerInfo.ownerPercentOwnership" class="general-input-custom"
                  fill="outline"></ion-input>
              </ion-item>
            </div>

            <div class="info-field">
              <p class="field-label">Social Security Number</p>
              <p *ngIf="!isOwnerInfoEditMode " class="field-value">{{ ownerInfo.ownerSocialSecurityNumber }}</p>
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-input [(ngModel)]="ownerInfo.ownerSocialSecurityNumber" class="general-input-custom"
                  fill="outline"></ion-input>
              </ion-item>
            </div>
          </div>

          <!-- Row 5 -->
          <div class="info-row">
            <div class="info-field">
              <p class="field-label">Estimated Personal Fico Rage</p>
              <p *ngIf="!isOwnerInfoEditMode " class="field-value">{{ ownerInfo.ownerEstimatedFICORange }}</p>
              <!-- <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-input [(ngModel)]="ownerInfo.ownerEstimatedFICORange" class="general-input-custom"
                  fill="outline"></ion-input>
              </ion-item> -->
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-select [(ngModel)]="ownerInfo.ownerEstimatedFICORange" class="general-input-custom" fill="outline"
                  interface="popover">
                  <ion-select-option value="300-550">300-550</ion-select-option>
                  <ion-select-option value="551-600">551-600</ion-select-option>
                  <ion-select-option value="601-650">601-650</ion-select-option>
                  <ion-select-option value="651-700">651-700</ion-select-option>
                  <ion-select-option value="701-750">701-750</ion-select-option>
                  <ion-select-option value="751-800">751-800</ion-select-option>
                  <ion-select-option value="800+">800+</ion-select-option>
                </ion-select>
              </ion-item>
            </div>

            <div class="info-field">
              <p class="field-label">Is there a second owner for business?</p>
              <p *ngIf="!isOwnerInfoEditMode " class="field-value">{{ ownerInfo.hasSecondOwner }}</p>
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-select [(ngModel)]="ownerInfo.hasSecondOwner" class="general-input-custom" fill="outline"
                  interface="popover">
                  <ion-select-option value="Yes">Yes</ion-select-option>
                  <ion-select-option value="No">No</ion-select-option>
                </ion-select>
              </ion-item>
            </div>
          </div>

        </div>

        <div *ngIf="ownerInfo.hasSecondOwner === 'Yes'" class="info-grid second-owner-section">
          <h4 class="esignTitle">Second Owner Information</h4>

          <!-- Row 1 -->
          <div class="info-row">
            <div class="info-field">
              <p class="field-label">Owner Name</p>
              <p *ngIf="!isOwnerInfoEditMode" class="field-value">{{ secondOwnerInfo.owner2Name }}</p>
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-input [(ngModel)]="secondOwnerInfo.owner2Name" class="general-input-custom"
                  fill="outline"></ion-input>
              </ion-item>
            </div>

            <div class="info-field">
              <p class="field-label">Owner Phone</p>
              <p *ngIf="!isOwnerInfoEditMode" class="field-value">{{ secondOwnerInfo.owner2Phone }}</p>
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-input [(ngModel)]="secondOwnerInfo.owner2Phone" class="general-input-custom" fill="outline"
                  type="tel"></ion-input>
              </ion-item>
            </div>
          </div>

          <!-- Row 2 -->
          <div class="info-row">
            <div class="info-field">
              <p class="field-label">Owner Address</p>
              <p *ngIf="!isOwnerInfoEditMode" class="field-value">{{ secondOwnerInfo.owner2Address }}</p>
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-input [(ngModel)]="secondOwnerInfo.owner2Address" class="general-input-custom"
                  fill="outline"></ion-input>
              </ion-item>
            </div>

            <div class="info-field">
              <p class="field-label">Owner Email</p>
              <p *ngIf="!isOwnerInfoEditMode" class="field-value">{{ secondOwnerInfo.owner2Email }}</p>
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-input [(ngModel)]="secondOwnerInfo.owner2Email" class="general-input-custom" fill="outline"
                  type="email"></ion-input>
              </ion-item>
            </div>
          </div>

          <!-- Row 3 -->
          <div class="info-row">
            <div class="info-field">
              <p class="field-label">Business Start Date</p>
              <p *ngIf="!isOwnerInfoEditMode" class="field-value">{{ secondOwnerInfo.owner2BusinessStartDate }}</p>
              <!-- <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-datetime-button datetime="secondOwnerBusinessStartDate"></ion-datetime-button>
                <ion-modal [keepContentsMounted]="true">
                  <ng-template>
                    <ion-datetime id="secondOwnerBusinessStartDate"
                      [(ngModel)]="secondOwnerInfo.owner2BusinessStartDate" presentation="date"></ion-datetime>
                  </ng-template>
                </ion-modal>
              </ion-item> -->
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-input [(ngModel)]="secondOwnerInfo.owner2BusinessStartDate" class="general-input-custom"
                  fill="outline"></ion-input>
              </ion-item>
            </div>

            <div class="info-field">
              <p class="field-label">Date of Birth</p>
              <p *ngIf="!isOwnerInfoEditMode" class="field-value">{{ secondOwnerInfo.owner2DateOfBirth }}</p>
              <!-- <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-datetime-button datetime="secondOwnerDOB"></ion-datetime-button>
                <ion-modal [keepContentsMounted]="true">
                  <ng-template>
                    <ion-datetime id="secondOwnerDOB" [(ngModel)]="secondOwnerInfo.owner2DateOfBirth"
                      presentation="date"></ion-datetime>
                  </ng-template>
                </ion-modal>
              </ion-item> -->
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-input [(ngModel)]="secondOwnerInfo.owner2DateOfBirth" class="general-input-custom"
                  fill="outline"></ion-input>
              </ion-item>
            </div>
          </div>

          <!-- Row 4 -->
          <div class="info-row">
            <div class="info-field">
              <p class="field-label">Percent Ownership</p>
              <p *ngIf="!isOwnerInfoEditMode" class="field-value">{{ secondOwnerInfo.owner2OwnershipPercentage }}</p>
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-input [(ngModel)]="secondOwnerInfo.owner2OwnershipPercentage" class="general-input-custom"
                  fill="outline"></ion-input>
              </ion-item>
            </div>

            <div class="info-field">
              <p class="field-label">Social Security Number</p>
              <p *ngIf="!isOwnerInfoEditMode" class="field-value">{{ secondOwnerInfo.owner2SocialSecurityNumber }}</p>
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-input [(ngModel)]="secondOwnerInfo.owner2SocialSecurityNumber" class="general-input-custom"
                  fill="outline" type="password"></ion-input>
              </ion-item>
            </div>
          </div>

          <!-- Row 5 -->
          <div class="info-row">
            <div class="info-field">
              <p class="field-label">Estimated FICO Range</p>
              <p *ngIf="!isOwnerInfoEditMode" class="field-value">{{ secondOwnerInfo.owner2EstimatedFICORange }}</p>
              <ion-item *ngIf="isOwnerInfoEditMode" lines="none">
                <ion-select [(ngModel)]="secondOwnerInfo.owner2EstimatedFICORange" class="general-input-custom"
                  fill="outline" interface="popover">
                  <ion-select-option value="300-550">300-550</ion-select-option>
                  <ion-select-option value="551-600">551-600</ion-select-option>
                  <ion-select-option value="601-650">601-650</ion-select-option>
                  <ion-select-option value="651-700">651-700</ion-select-option>
                  <ion-select-option value="701-750">701-750</ion-select-option>
                  <ion-select-option value="751-800">751-800</ion-select-option>
                  <ion-select-option value="800+">800+</ion-select-option>
                </ion-select>
              </ion-item>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="termsWrapper">
      <p class="termsText">
        I understand that by checking the box below, I am confirming that:
      </p>
      <ion-list>
        <ion-item lines="inset">
          <p class="termsDetailText">
            To the best of my knowledge, the business and owner information I reviewed above pages is accurate and
            complete
          </p>
        </ion-item>
        <ion-item lines="inset">
          <p class="termsDetailText">
            hereby provides its written instructions to Finance Logic and its affiliates, agents, or third-party
            service
            providers to obtain business and/or credit reports about in connection with this application.
          </p>
        </ion-item>
        <ion-item lines="inset">
          <p class="termsDetailText">
            I hereby provide my written instructions to Revenued, LLC under the Fair Credit Reporting Act permitting
            Revenued, LLC and its affiliates, agents, or third-party service providers, to obtain one or more consumer
            report(s) about me, including any credit reports and/or credit score, from one or more consumer reporting
            agencies in connection with ’s application for business funding, and any subsequent account review or
            collection activities related to the account.
          </p>
        </ion-item>
        <ion-item lines="inset">
          <p class="termsDetailText">
            I understand the <a href="/privacy-policy" target="_blank">Privacy Policy</a>.
          </p>
        </ion-item>
      </ion-list>
      <div class="termsCheckboxWrapper">
        <div class="termsCheckbox">
          <ion-checkbox [(ngModel)]="termsAccepted" color="primary" labelPlacement="end">
            <p class="checkboxLabel">I confirm and agree to all the statements above</p>
          </ion-checkbox>

        </div>

        <app-primary-button [disabled]="!termsAccepted" [label]="'Submit E-Sign'" [loading]="false"
          customClass="primaryBtn" (clicked)="completeESign()" iconOrder="right" ionIconName="arrow-forward-outline">
        </app-primary-button>
      </div>

    </div>
  </div>
</ion-content>